module.exports = __webpack_public_path__ + "img/defaulavatar@2x.eed8c76.png";